import { z } from 'zod';
import { ResourceLibrarySitePageBaseItem } from '../types/resourceLibrarySitePageItems';
import {
    GetResourceLibrarySitePageItemListingSchema,
    ResourceLibrarySitePageBaseItemSchema,
} from '../schemas/resourceLibrarySitePageItemZodSchemas';
import { hydrateResourceLibrarySitePageBaseItem } from './transformResourceLibrarySitePageItemResponse';

export function transformResourceLibrarySitePageItemsResponse(
    data: unknown
): ResourceLibrarySitePageBaseItem[] {
    const parsedResult = GetResourceLibrarySitePageItemListingSchema.safeParse(data);

    if (!parsedResult.success) {
        console.error(
            'Validation failed for getResourceLibrarySitePageItemListing:',
            parsedResult.error.errors
        );
        return [];
    }

    const edges = parsedResult.data.getResourceLibrarySitePageItemListing.edges;

    const items: ResourceLibrarySitePageBaseItem[] = [];

    edges.forEach(({ node }) => {
        const item = node as z.infer<typeof ResourceLibrarySitePageBaseItemSchema>;
        items.push(hydrateResourceLibrarySitePageBaseItem(item));
    });

    return items;
}
